"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomHeaders = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const CustomHeader_1 = require("./CustomHeader");
const ConfigSection_1 = require("../../ConfigSection");
const CustomHeaders = ({ headers: headersFromProps, onChange, readOnly }) => {
    const { spacing } = (0, ui_1.useTheme2)();
    const [headers, setHeaders] = (0, react_1.useState)(headersFromProps.map((header) => (Object.assign(Object.assign({}, header), { id: uniqueId(), value: '' }))));
    (0, react_1.useEffect)(() => {
        setHeaders((headers) => {
            let changed = false;
            const newHeaders = headers.map((header) => {
                var _a;
                const configured = (_a = headersFromProps.find((h) => h.name === header.name)) === null || _a === void 0 ? void 0 : _a.configured;
                if (typeof configured !== 'undefined' && header.configured !== configured) {
                    changed = true;
                    return Object.assign(Object.assign({}, header), { configured });
                }
                return header;
            });
            if (changed) {
                return newHeaders;
            }
            return headers;
        });
    }, [headersFromProps]);
    const onHeaderAdd = () => {
        setHeaders([...headers, { id: uniqueId(), name: '', value: '', configured: false }]);
    };
    const onHeaderChange = (id, header) => {
        setHeaders(headers.map((h) => (h.id === id ? Object.assign({}, header) : h)));
    };
    const onHeaderDelete = (id) => {
        const index = headers.findIndex((h) => h.id === id);
        if (index === -1) {
            return;
        }
        const newHeaders = [...headers];
        newHeaders.splice(index, 1);
        setHeaders(newHeaders);
        onChange(newHeaders.map(({ name, value, configured }) => ({
            name,
            value,
            configured,
        })));
    };
    const onBlur = () => {
        onChange(headers.map(({ name, value, configured }) => ({
            name,
            value,
            configured,
        })));
    };
    const styles = {
        container: (0, css_1.css)({
            marginTop: spacing(3),
        }),
        addHeaderButton: (0, css_1.css)({
            marginTop: spacing(1.5),
        }),
    };
    return (react_1.default.createElement("div", { className: styles.container },
        react_1.default.createElement(ConfigSection_1.ConfigSubSection, { title: "HTTP headers", description: "Pass along additional context and metadata about the request/response", isCollapsible: true, isInitiallyOpen: headers.length > 0 },
            react_1.default.createElement("div", null, headers.map((header) => (react_1.default.createElement(CustomHeader_1.CustomHeader, { key: header.id, header: header, onChange: (header) => onHeaderChange(header.id, header), onDelete: () => onHeaderDelete(header.id), onBlur: onBlur, readOnly: readOnly })))),
            react_1.default.createElement("div", { className: styles.addHeaderButton },
                react_1.default.createElement(ui_1.Button, { icon: "plus", variant: "secondary", fill: "outline", onClick: onHeaderAdd, disabled: readOnly }, headers.length === 0 ? 'Add header' : 'Add another header')))));
};
exports.CustomHeaders = CustomHeaders;
function uniqueId() {
    return Math.random().toString(16).slice(2);
}
//# sourceMappingURL=CustomHeaders.js.map